import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

/**
 * A reusable full-screen loader component with a semi-transparent overlay
 * 
 * @param {Object} props
 * @param {number} [props.spinnerSize=60] - Size of the CircularProgress component
 * @param {number} [props.spinnerThickness=4] - Thickness of the CircularProgress component
 * @param {string} [props.backgroundColor='rgba(0, 0, 0, 0.7)'] - Background color of the overlay
 * @param {number} [props.zIndex=10000] - z-index of the loader container
 */
const Loader = ({
  spinnerSize = 60,
  spinnerThickness = 5,
  backgroundColor = 'rgba(0, 0, 0, 0.7)',
  zIndex = 9999, // Increased z-index to be above everything
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor,
        zIndex: zIndex, // Higher z-index to appear above left drawer
        backdropFilter: 'blur(2px)',
      }}
    >
      <CircularProgress 
        size={spinnerSize} 
        thickness={spinnerThickness} 
        sx={{ color: '#FFFFFF' }}
      />
    </Box>
  );
};

Loader.propTypes = {
  spinnerSize: PropTypes.number,
  spinnerThickness: PropTypes.number,
  backgroundColor: PropTypes.string,
  zIndex: PropTypes.number
};

export default Loader;
